export default __webpack_public_path__ + "static/media/img4.10c3ac7c.jpg";